<div class="navbar-container" [class.example-is-mobile]="mobileQuery.matches">

  <!-- Top navbar -->
  <mat-toolbar class="navbar red" color="">

    <a class="navbar-brand-simple" [routerLink]="['/']" matTooltip="Home">
      <img src="../../../assets/favicon/ico_qsign.svg" class="navbar-icon" style="height: 32px;" />
      <h1>
        {{'APP_TITLE' | translate}}
      </h1>
    </a>

    <span class="navbar-spacer"></span>

    <!-- Switch Language Button -->
    <button (click)="reloadPage()" class="lang-switch">
      {{ selectedLanguageLabel === 'sk' ? 'SK' : 'EN' }}
    </button>

    <!-- <button mat-icon-button [matMenuTriggerFor]="notificationMenu">
    <mat-icon matBadge="2" matBadgeColor="accent">notifications</mat-icon>
  </button>
  <mat-menu #notificationMenu="matMenu" xPosition="before" yPosition="above" [overlapTrigger]="false">

    <a mat-menu-item>
      <span>You have new tasks assigned</span>
    </a>
    <a mat-menu-item>
      <span>New requests completed</span>
    </a>

  </mat-menu>

  <button mat-button [matMenuTriggerFor]="userMenu" id="user-menu">
    <mat-icon>person</mat-icon>
    <span fxShow fxHide.xs>
      {{userName}}
    </span>
  </button>
  <mat-menu #userMenu="matMenu" xPosition="before" yPosition="above" [overlapTrigger]="false">

    <a mat-menu-item (click)="openProfile()">
      <mat-icon>person</mat-icon>
      <span>Account</span>
    </a>

    <a mat-menu-item (click)="logout()">
      <mat-icon>exit_to_app</mat-icon>
      <span>Log out</span>
    </a>

  </mat-menu> -->

</mat-toolbar>

<mat-sidenav-container class="navbar-sidenav-container ard-sidenav">
  <!-- Side nav -->
  <mat-sidenav #snav [opened]="false" [mode]="mobileQuery.matches ? 'over' : 'side'"
    [fixedInViewport]="mobileQuery.matches" fixedTopGap="56" class="sidenav">

    <!-- <mat-nav-list class="ard-navlist">

    <a mat-list-item [routerLink]="['/dashboard']" routerLinkActive="active">
      <div class="item-content">
        <mat-icon mat-list-icon>
          dashboard
        </mat-icon>
        <span>{{'MENU_ITEM_DASHBOARD' | translate}}</span>
      </div>
    </a>

    <a mat-list-item [routerLink]="['/new-request']" routerLinkActive="active" class="list-item">
      <div class="item-content">
        <mat-icon mat-list-icon>
          create
        </mat-icon>
        <span>{{'MENU_ITEM_NEW_REQUEST' | translate}}</span>
      </div>
    </a>

    <a mat-list-item [routerLink]="['/my-requests']" routerLinkActive="active">
      <div class="item-content">
        <mat-icon mat-list-icon>
          view_list
        </mat-icon>
        <span>{{'MENU_ITEM_MY_REQUESTS' | translate}}</span>
      </div>
    </a>

    <a id="push-bottom" mat-list-item [routerLink]="['/about']" routerLinkActive="active">
      <div class="item-content">
        <mat-icon mat-list-icon>
          info_outline
        </mat-icon>
        <p mat-line> {{'MENU_ITEM_ABOUT' | translate}} </p>
      </div>
    </a>
  </mat-nav-list> -->


</mat-sidenav>

<!-- Main content -->
<mat-sidenav-content class="sidenav-content">

  <div class="progress-bar-container">
    @if (spinnerService.visibility | async) {
      <mat-progress-bar color="accent" mode="indeterminate">
      </mat-progress-bar>
    }
    <!-- <mat-spinner class="spinner" [diameter]="50" *ngIf="showSpinner"></mat-spinner> -->
  </div>


  <router-outlet></router-outlet>

</mat-sidenav-content>
</mat-sidenav-container>

</div>